import { useEffect, useMemo, useState } from 'react';
import { type TSitewideBanner, type TSitewideBannerScene } from './types';
import Scene from './Scene';
import parseJson from '@utils/parseJson';

const SitewideBanner: React.FC<{ banner: TSitewideBanner }> = ({ banner: rawBanner }) => {
  const banner = useMemo(() => {
    return parseJson(rawBanner);
  }, [rawBanner]);

  const [scenes, setScenes] = useState<TSitewideBannerScene[]>(banner.scenes || []);
  const hasRotation = useMemo(() => scenes.length > 1, [scenes]);

  useEffect(() => {
    if (!hasRotation) return;
    const id = window.setInterval(() => {
      setScenes((prev) => (prev.length > 1 ? [...prev.slice(1), prev[0]] : prev));
    }, 3500);
    return () => window.clearInterval(id);
  }, [hasRotation]);

  if (!banner || scenes.length === 0) return null;

  return (
    <div className='tw:flex tw:overflow-hidden'>
      {scenes.map((scene) => (
        <Scene key={scene.id} scene={scene} />
      ))}
    </div>
  );
};

export default SitewideBanner;
